import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "involved-data"
};
var _hoisted_2 = {
  class: "interaction mrg16"
};
var _hoisted_3 = {
  class: "tab-analysis"
};
var _hoisted_4 = {
  class: "body-all mrg16"
};
var _hoisted_5 = {
  class: "teach-detail mrg16"
};
var _hoisted_6 = {
  key: 1,
  class: "empty-box"
};
import { ref, onMounted, computed, reactive } from 'vue';
/** 组件 */
import formItem from './components/formItem';
import dobarAnalysis from './components/dobarAnalysis';
import teachTab from './components/teachTab';
import mTable from './components/table';
// 工具
import { getStore } from '@/util/store';
/** 接口 */
import { getClassTeacher, getTimeTeacherPeriod, getGroupAndMemberDetail, getInteractionAndParticipation } from '@/api/index-jiao.js';
import { appAliasInfo } from '@/utils/auth';
import { teacherColumn } from './const/table';
export default {
  __name: 'Involved',
  setup: function setup(__props) {
    var emptyImage = require("./images/empty-chart.png");
    var noAuthImage = require('@/assets/home/dataReport/images/empty-icon.png');
    var userInfo = getStore({
      name: 'userInfo'
    }); // 获取用户信息
    var classTypeOptions = [{
      label: '行政班',
      value: 3
    }, {
      label: '教学班',
      value: 4
    }]; // 班级类型
    var classType = ref(3);
    var classOptions = ref([]); // 班级
    var classRoom = ref('');
    var cycleOptions = ref([]); /// / 时间周期
    var cycle = ref('');
    // 存储各个接口返回的总体数据
    var states = reactive({
      interactData: {} // 互动与参与
    });
    var tableLoading = ref(false);
    var interactLoading = ref(false);
    // const echartdata = {
    //   title: '本周课堂组织情况',
    //   legend: ['用课平台次数', '学程授课占比', '展示次数占比', '有展示课次学生参与率'],
    //   xAxis: ['六年级', '七年级', '八年级', '九年级', '高一', '高二', '高三'],
    //   series: [
    //     { name: '用课平台次数', data: [300, 650, 1700, 520, 639, 500, 300] },
    //     { name: '学程授课占比', data: [200, 0.8, 0.4, 0.8, 0.95, 0.6, 0.5] },
    //     { name: '展示次数占比', data: [0.8, 0.6, 300, 0.8, 200, 0.4, 0.955] },
    //     { name: '有展示课次学生参与率', data: [0.8, 0.95, 0.6, 400, 0.4, 0.8, 0.6] },
    //   ],
    // }
    var showinteract = computed(function () {
      var series = states.interactData.series;
      if (!series) {
        return false;
      }
      var isNowNone = series.some(function (item) {
        var bool = false;
        if (item && item.data.length > 0) {
          bool = item.data.some(function (itm) {
            return itm > 0;
          });
        }
        return bool;
      });
      return isNowNone;
    });
    var classTypeName = computed(function () {
      var _classTypeOptions$fin;
      return (_classTypeOptions$fin = classTypeOptions.find(function (item) {
        return item.value === classType.value;
      })) === null || _classTypeOptions$fin === void 0 ? void 0 : _classTypeOptions$fin.label;
    });
    var className = computed(function () {
      var _classOptions$value$f;
      return (_classOptions$value$f = classOptions.value.find(function (item) {
        return item.value === classRoom.value;
      })) === null || _classOptions$value$f === void 0 ? void 0 : _classOptions$value$f.label;
    });
    /** 初始化相关_方法 */
    var hasData = ref(false);
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _yield$appAliasInfo, hasAuth, auth, index;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return appAliasInfo('dataView');
          case 1:
            _yield$appAliasInfo = _context.v;
            hasAuth = _yield$appAliasInfo.hasAuth;
            auth = _yield$appAliasInfo.auth;
            // console.log(hasAuth, auth, '---hasAuth, auth')
            if (hasAuth && auth) {
              index = auth.findIndex(function (itm) {
                return itm.permission === 'teacher';
              });
              hasData.value = index > -1;
            }
            _context.n = 2;
            return getClassTeacherData();
          case 2:
            _context.n = 3;
            return getTimeTeacherPeriodData();
          case 3:
            defaultGetData();
          case 4:
            return _context.a(2);
        }
      }, _callee);
    })));

    /** 事件相关 */
    // 获取班级数据
    var getClassTeacherData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              // console.log('todo', userInfo.value.id)
              data = {
                userId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id,
                classType: classType.value
              };
              _context2.n = 1;
              return getClassTeacher(data).then(function (res) {
                if (res.data.data && res.data.data.length > 0) {
                  classOptions.value = res.data.data;
                  classRoom.value = classOptions.value[0].value;
                } else {
                  classOptions.value = [];
                  classRoom.value = '';
                }
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function getClassTeacherData() {
        return _ref2.apply(this, arguments);
      };
    }();
    // 修改班级类型
    var handleChangeClass = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return getClassTeacherData();
            case 1:
              defaultGetData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function handleChangeClass() {
        return _ref3.apply(this, arguments);
      };
    }();

    // 获取周期
    var getTimeTeacherPeriodData = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return getTimeTeacherPeriod().then(function (res) {
                if (res.data.data) {
                  cycleOptions.value = res.data.data;
                  cycle.value = res.data.data[0].value;
                } else {
                  cycleOptions.value = [];
                }
              });
            case 1:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function getTimeTeacherPeriodData() {
        return _ref4.apply(this, arguments);
      };
    }();
    // 修改班级，时间周期
    var handleChange = function handleChange() {
      defaultGetData();
    };
    var defaultGetData = function defaultGetData() {
      // 互动与参与
      getAnalysisData();
      // 教师授课详情
      size.value = 20;
      current.value = 1;
      getGroupAndMemberData();
    };
    // 获取图标数据
    var getAnalysisData = function getAnalysisData() {
      interactLoading.value = true;
      var data = {
        classRoom: classRoom.value,
        cycle: cycle.value
      };
      // 互动与参与
      getInteractionAndParticipation(data).then(function (res) {
        states.interactData = res.data.data;
        interactLoading.value = false;
      }).catch(function (err) {
        interactLoading.value = false;
      });
    };
    // 表格数据
    var columns = ref(teacherColumn);
    var tdata = ref([]);
    var size = ref(20);
    var current = ref(1);
    var groupId = ref('');
    var studentId = ref('');
    var total = ref(0);
    // 获取教师授课详情
    var getGroupAndMemberData = function getGroupAndMemberData() {
      tableLoading.value = true;
      var data = {
        classRoom: classRoom.value,
        cycle: cycle.value,
        groupId: groupId.value,
        studentId: studentId.value,
        size: size.value,
        current: current.value
      };
      getGroupAndMemberDetail(data).then(function (res) {
        // console.log(res.data.data, 272)
        tdata.value = res.data.data.records.map(function (item) {
          item.studentRate = item.studentRate + '%';
          item.detectionRate = item.detectionRate + '%';
          return item;
        });
        total.value = res.data.data.total;
        tableLoading.value = false;
      }).catch(function (err) {
        tableLoading.value = false;
      });
    };
    var changePageSize = function changePageSize(val) {
      current.value = 1;
      size.value = val;
      getGroupAndMemberData();
    };
    var changeCurrent = function changeCurrent(num) {
      current.value = num;
      getGroupAndMemberData();
    };
    // 切换有无，班级数据信息 获取教师授课详情
    var handleChangeTab = function handleChangeTab(val) {
      // console.log(val)
      groupId.value = val.groupId;
      studentId.value = val.studentId;
      size.value = 20;
      current.value = 1;
      getGroupAndMemberData();
    };
    return function (_ctx, _cache) {
      var _component_t_select = _resolveComponent("t-select");
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_loading = _resolveComponent("t-loading");
      var _component_Empty = _resolveComponent("Empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [hasData.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", null, [_createVNode(_unref(formItem), {
        class: "margin-l0"
      }, {
        formLabel: _withCtx(function () {
          return _toConsumableArray(_cache[3] || (_cache[3] = [_createTextVNode(" 班级类型 ", -1)]));
        }),
        formInput: _withCtx(function () {
          return [_createVNode(_component_t_select, {
            modelValue: classType.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return classType.value = $event;
            }),
            options: classTypeOptions,
            onChange: handleChangeClass
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }), _createVNode(_unref(formItem), null, {
        formLabel: _withCtx(function () {
          return _toConsumableArray(_cache[4] || (_cache[4] = [_createTextVNode(" 班级 ", -1)]));
        }),
        formInput: _withCtx(function () {
          return [_createVNode(_component_t_select, {
            modelValue: classRoom.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return classRoom.value = $event;
            }),
            keys: {
              label: 'name',
              value: 'value'
            },
            options: classOptions.value,
            onChange: handleChange
          }, null, 8, ["modelValue", "options"])];
        }),
        _: 1
      }), _createVNode(_unref(formItem), null, {
        formLabel: _withCtx(function () {
          return _toConsumableArray(_cache[5] || (_cache[5] = [_createTextVNode(" 时间周期 ", -1)]));
        }),
        formInput: _withCtx(function () {
          return [_createVNode(_component_t_select, {
            modelValue: cycle.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return cycle.value = $event;
            }),
            keys: {
              label: 'name',
              value: 'value'
            },
            options: cycleOptions.value,
            onChange: handleChange
          }, null, 8, ["modelValue", "options"])];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_svg_icon, {
        size: "28",
        name: "db-analys"
      }), _cache[6] || (_cache[6] = _createElementVNode("span", null, "互动与参与", -1))]), _createElementVNode("div", _hoisted_4, [interactLoading.value ? (_openBlock(), _createBlock(_component_t_loading, {
        key: 0,
        class: "interact-loading"
      })) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [showinteract.value ? (_openBlock(), _createBlock(_unref(dobarAnalysis), {
        key: 0,
        id: "echart3",
        data: states.interactData
      }, null, 8, ["data"])) : (_openBlock(), _createBlock(_component_Empty, {
        key: 1,
        icon: _unref(emptyImage),
        class: "empty",
        size: 160
      }, null, 8, ["icon"]))], 64))])]), _createElementVNode("div", _hoisted_5, [_createVNode(_unref(teachTab), {
        class: "tab-class",
        "out-class-name": className.value,
        outClassType: classTypeName.value,
        cycle: cycle.value,
        "class-id": classRoom.value,
        onChangeTab: handleChangeTab
      }, {
        title: _withCtx(function () {
          return _toConsumableArray(_cache[7] || (_cache[7] = [_createTextVNode(" 小组及成员详细数据表 ", -1)]));
        }),
        _: 1
      }, 8, ["out-class-name", "outClassType", "cycle", "class-id"]), _createVNode(_unref(mTable), {
        class: "mrg16",
        columns: columns.value,
        tdata: tdata.value,
        total: total.value,
        pageSize: size.value,
        current: current.value,
        loading: tableLoading.value,
        onChangeCurrent: changeCurrent,
        onChangePageSize: changePageSize
      }, null, 8, ["columns", "tdata", "total", "pageSize", "current", "loading"])])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_Empty, {
        icon: _unref(noAuthImage)
      }, {
        description: _withCtx(function () {
          return _toConsumableArray(_cache[8] || (_cache[8] = [_createElementVNode("div", {
            class: "empty-des"
          }, [_createElementVNode("p", null, "当前尚无任何数据权限"), _createElementVNode("p", null, "请找管理员进行应用授权范围设定")], -1)]));
        }),
        _: 1
      }, 8, ["icon"])]))]);
    };
  }
};